import { RouterProvider } from '@tanstack/react-router';
import { router } from './app/router';
import { useEffect } from 'react';
import { useAppDispatch } from './app/store';
import { logout, sessionRefreshed } from './features/auth/slice';
import { setLogoutCallback, setSessionRefreshedCallback } from './services/api';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';
import { ThemeModeProvider } from './theme/ThemeModeProvider';

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    setLogoutCallback(() => {
      dispatch(logout());
      router.navigate({ to: '/login', replace: true });
    });

    setSessionRefreshedCallback((tokenResponse) => {
      dispatch(
        sessionRefreshed({
          accessToken: tokenResponse.access_token,
          homePageUrl: tokenResponse.home_page_url,
          logoPageUrl: tokenResponse.logo_page_url,
        })
      );
    });
  }, [dispatch]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <ThemeModeProvider>
        <RouterProvider router={router} />
      </ThemeModeProvider>
    </LocalizationProvider>
  );
}

export default App;
